function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object, disabled, inputValue) {
    var h = require("panel").h;
    const attrObj = Object.entries($component.attrs()).reduce((acc, [attrName, attrVal]) => Object.assign(acc, {
      [attrName]: attrVal
    }), {
      type: 'text'
    });
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-icon-input-disabled': disabled
        }, {
          'mp-icon-input-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-icon-input-icon': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`icon`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: $attr(`icon`)
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": attrObj,
          "on": {
            input: $helpers.handleInput
          },
          "props": {
            value: inputValue
          },
          "hook": {
            insert: ({
              elm
            }) => $component.setElmRef(elm)
          },
          "class": {
            'mp-icon-input-input': true
          },
        }));
        __jade_nodes = __jade_nodes.concat((inputValue) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-icon-input-clear-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: `circle-clear`
              },
              "on": {
                click: $helpers.clearInput
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "disabled" in locals ? locals.disabled : typeof disabled !== "undefined" ? disabled : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;